export function productName(name: string) {
    return name.replace('&amp;', '&');
}
